export default __webpack_public_path__ + "static/media/whiteexport.f80b69df.svg";